import React from 'react';

const IOSFallback = ({ user, userData, onRefresh, onClearData }) => {
    return (
        <div style={{
            backgroundColor: '#1f2937',
            color: 'white',
            minHeight: '100vh',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }}>
            <h1 style={{ fontSize: '24px', marginBottom: '20px' }}>
                🍎 iOS Compatibility Mode
            </h1>
            
            <p style={{ marginBottom: '20px', maxWidth: '400px' }}>
                เกิดปัญหาในการโหลดแอปบน iOS Safari กรุณาลองวิธีแก้ไขด้านล่าง
            </p>

            <div style={{ 
                backgroundColor: '#374151', 
                padding: '15px', 
                borderRadius: '8px',
                marginBottom: '30px',
                fontSize: '14px'
            }}>
                <strong>ข้อมูลผู้ใช้:</strong><br/>
                User: {user ? '✅ ล็อกอินแล้ว' : '❌ ยังไม่ได้ล็อกอิน'}<br/>
                UserData: {userData ? '✅ โหลดแล้ว' : '❌ ยังไม่ได้โหลด'}<br/>
                Email: {user?.email || 'ไม่ระบุ'}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%', maxWidth: '300px' }}>
                <button 
                    onClick={onRefresh}
                    style={{
                        backgroundColor: '#3b82f6',
                        color: 'white',
                        border: 'none',
                        padding: '12px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '16px'
                    }}
                >
                    🔄 รีเฟรชหน้า
                </button>
                
                <button 
                    onClick={onClearData}
                    style={{
                        backgroundColor: '#ef4444',
                        color: 'white',
                        border: 'none',
                        padding: '12px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '16px'
                    }}
                >
                    🗑️ ล้างข้อมูลและรีเฟรช
                </button>
                
                <button 
                    onClick={() => window.location.href = 'https://fastlanelv.web.app'}
                    style={{
                        backgroundColor: '#10b981',
                        color: 'white',
                        border: 'none',
                        padding: '12px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '16px'
                    }}
                >
                    🏠 กลับหน้าหลัก
                </button>
            </div>

            <div style={{ 
                marginTop: '30px', 
                fontSize: '12px', 
                color: '#9ca3af',
                maxWidth: '400px'
            }}>
                <p><strong>คำแนะนำสำหรับ iOS:</strong></p>
                <p>• ใช้ Safari แทน Chrome หรือ Firefox</p>
                <p>• ปิด Private Browsing Mode</p>
                <p>• อัปเดต iOS เป็นเวอร์ชันล่าสุด</p>
                <p>• ล้าง Safari Cache ใน Settings</p>
            </div>
        </div>
    );
};

export default IOSFallback;